import { render, staticRenderFns } from "./ead-curso-player.vue?vue&type=template&id=f5ef1a16&scoped=true&"
import script from "./ead-curso-player.vue?vue&type=script&lang=js&"
export * from "./ead-curso-player.vue?vue&type=script&lang=js&"
import style0 from "./ead-curso-player.vue?vue&type=style&index=0&id=f5ef1a16&prod&scoped=true&lang=css&"
import style1 from "./ead-curso-player.vue?vue&type=style&index=1&id=f5ef1a16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ef1a16",
  null
  
)

export default component.exports